export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  image: string;
  imageAlt: string;
  date: string;
  readTime: string;
  slug: string;
  category: string;
}

export const blogPosts: BlogPost[] = [
  {
    id: 'home-dashboard',
    title: 'Home Dashboard: Your Daily Bladder Health at a Glance',
    excerpt: 'Track your fluid balance in real-time with our intelligent 24-hour rolling dashboard. See intake, output, and balance with visual gauges and instant insights.',
    image: '/screenshots/IMG_1355.PNG',
    imageAlt: 'PeeTrack Home Dashboard showing daily fluid balance',
    date: 'January 2026',
    readTime: '5 min read',
    slug: '/blog/home-dashboard',
    category: 'Features',
  },
  {
    id: 'quick-entry',
    title: 'Quick Entry: Log Your Fluids in Seconds',
    excerpt: 'Effortless data entry with preset volumes, voice input, and smart time stamping. Track drinks and output in just 5 seconds with our streamlined interface.',
    image: '/screenshots/IMG_1356.PNG',
    imageAlt: 'Quick entry interface for logging fluids',
    date: 'January 2026',
    readTime: '4 min read',
    slug: '/blog/quick-entry',
    category: 'Features',
  },
  {
    id: 'history-view',
    title: 'History View: Your Complete Bladder Health Journey',
    excerpt: 'Navigate your tracking history with an intuitive calendar view. Identify patterns, export reports, and share secure snapshots with your healthcare team.',
    image: '/screenshots/IMG_1357.PNG',
    imageAlt: 'Calendar-based history view with daily tracking data',
    date: 'January 2026',
    readTime: '6 min read',
    slug: '/blog/history-view',
    category: 'Features',
  },
  {
    id: 'analytics-insights',
    title: 'Analytics & Insights: AI-Powered Bladder Health Intelligence',
    excerpt: 'Transform your data into actionable insights with Claude AI. Get personalized recommendations, trend analysis, and early warning detection for potential issues.',
    image: '/screenshots/IMG_1358.PNG',
    imageAlt: 'Analytics dashboard with AI-powered insights',
    date: 'January 2026',
    readTime: '7 min read',
    slug: '/blog/analytics-insights',
    category: 'AI Features',
  },
  {
    id: 'settings-customization',
    title: 'Settings & Customization: Make PeeTrack Truly Yours',
    excerpt: 'Customize every aspect of your tracking experience. Set reminders, configure daily tasks, manage doctor sharing, and personalize the interface to match your needs.',
    image: '/screenshots/IMG_1359.PNG',
    imageAlt: 'Settings screen with collapsible sections',
    date: 'January 2026',
    readTime: '6 min read',
    slug: '/blog/settings-customization',
    category: 'Customization',
  },
  {
    id: 'multi-language-support',
    title: 'Multi-Language Support: Health Tracking Without Barriers',
    excerpt: 'Access PeeTrack in 8 languages with full localization. Professional translations, cultural adaptations, and language-specific features make bladder tracking accessible worldwide.',
    image: '/screenshots/IMG_1360.PNG',
    imageAlt: 'Multi-language selection interface',
    date: 'January 2026',
    readTime: '5 min read',
    slug: '/blog/multi-language-support',
    category: 'Accessibility',
  },
];
